import clsx from "clsx";
import type { ComponentProps } from "react";

import type { StrapiMedia } from "@shared/content-types/schemas/media.schema";
import { BrandIcon } from "@shared/ui/brand-icon";
import { Image } from "@shared/ui/image";
import { Body, Heading } from "@shared/ui/typography";

import type { BenefitsType, InfoSectionType } from "../../model";

import s from "./info.module.scss";

export type CompProps = ComponentProps<"div"> & {
  info: InfoSectionType;
  className?: string;
  image?: StrapiMedia;
};

export const InfoSection = (props: CompProps) => {
  const { info, className, image } = props;

  return (
    <section className={clsx(s.root, className)}>
      {image?.url && (
        <Image
          className={s.mainImage}
          src={image.url}
          alt={image.alternativeText ?? "about info"}
          height="100%"
        />
      )}
      <div
        className={clsx(s.content, {
          [s.withoutPadding]: !image?.url,
        })}
      >
        <div className={s.text}>
          {info.description && (
            <Heading level={6} tag="p">
              {info.description}
            </Heading>
          )}
          {info.workTime && (
            <div className={s.workTime}>
              <BrandIcon
                name="clock"
                fillColor="azure"
                strokeColor="milk"
                className={s.workTimeIcon}
              />
              <Heading level={6} tag="p">
                {info.workTime}
              </Heading>
            </div>
          )}
        </div>
        <ol className={s.list}>
          {info?.benefits?.map((item: BenefitsType) => (
            <li key={item.title} className={s.benefit}>
              {item?.icons?.icon?.name && (
                <BrandIcon
                  name={item.icons.icon.name}
                  fillColor={item.icons.fillColor}
                  strokeColor={item.icons.strokeColor}
                  svg_code={item.icons.uicon?.svg_code}
                  className={s.benefitIcon}
                />
              )}
              <div className={s.benefitText}>
                {item.title && (
                  <Heading level={6} tag="p" className={s.benefitTitle}>
                    {item.title}
                  </Heading>
                )}
                {item.description && (
                  <Body size="caption">{item.description}</Body>
                )}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

InfoSection.displayName = "InfoSection";
